var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlayAudioBlack = function SvgIconPlayAudioBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M16.655 7.717 4.014.587a2.69 2.69 0 0 0-2.706.02 2.6 2.6 0 0 0-1.31 2.262v14.262a2.6 2.6 0 0 0 1.31 2.262 2.7 2.7 0 0 0 2.706.02l12.64-7.13a2.61 2.61 0 0 0 0-4.566"
  })));
};
export default SvgIconPlayAudioBlack;